import React, { Component } from 'react'
import Design from './design'

export default class SelectDesign extends Component {
  render () {
    const designs = this.props.designs.map((design, i) => {
      return (
        <Design
          key={i}
          design={design}
          selected={this.props.selected === design}
          onSelect={this.props.onSelect}
        />
      )
    })
    return <div className="designs_list">{designs}</div>
  }
}
